import style from "./Phases.module.css";
import ContentEditable from "react-contenteditable";
import sanitizeHTML from "sanitize-html";
import { db } from "../../../configs/Firebase";
import { ref, update } from "firebase/database";
import { useEffect, useState } from "react";

const Phases = (props) => {
  const [hasRendered, setHasRendered] = useState(false);
  const [cellVal, setCellVal] = useState("");

  useEffect(() => {
    if (!props.editable || !hasRendered) {
      setCellVal(props.data.value);
    }
    setHasRendered(true);
  }, [props.data.value]);

  function onChangeHandler(e, columnId) {
    // Extract plain text from HTML to prevent storing HTML markup
    let plainText = e.target.value;
    if (plainText) {
      const tmp = document.createElement("div");
      tmp.innerHTML = plainText;
      plainText = tmp.textContent || tmp.innerText || "";
    }
    update(ref(db), {
      [props.journeyRefURL +
      "/rows/" +
      props.row.id +
      "/columns/" +
      columnId +
      "/value"]: sanitizeHTML(plainText),
    });
    setCellVal(plainText);
  }

  // Handle paste events to strip HTML and only allow plain text
  function handlePaste(e) {
    e.preventDefault();
    const text = (e.clipboardData || window.clipboardData).getData('text/plain');
    document.execCommand('insertText', false, text);
  }

  function selectAll(e) {
    var range, selection;
    if (document.body.createTextRange) {
      range = document.body.createTextRange();
      range.moveToElementText(e.currentTarget);
      range.select();
    } else if (window.getSelection) {
      selection = window.getSelection();
      range = document.createRange();
      range.selectNodeContents(e.currentTarget);
      selection.removeAllRanges();
      selection.addRange(range);
    }
  }

  return (
    <div
      className={`${style.cell} ${style[props.data.style]} ${
        props.first && style.first
      } ${props.last && style.last} ${
        props.editable ? style.editable : null
      }`}
    >
      <div>
        {props.editable ? (
          <ContentEditable
            html={cellVal}
            onChange={(e) => onChangeHandler(e, props.cellIndex)}
            onPaste={handlePaste}
            onFocus={(e) => selectAll(e)}
          />
        ) : (
          <div
            dangerouslySetInnerHTML={{
              __html: sanitizeHTML(cellVal),
            }}
          />
        )}
      </div>
    </div>
  );
};

export default Phases;
